module.exports = __webpack_public_path__ + "img/gjzy.84aa724c.jpg";